export function getCommonStates(editorState) {
  const content = editorState.getCurrentContent();
  const selection = editorState.getSelection();
  const anchorKey = selection.getAnchorKey();
  const block = content.getBlockForKey(anchorKey);
  return {block, content, selection};
}